import React from "react";
import { Colors } from "../../../../../shared/theme";
import { textStyles } from "../../../../../shared/theme/fonts-ppv";

export default {
  form: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    backgroundColor: "transparent",
  } as React.CSSProperties,
  formSection: {
    padding: "28px 30px 30px",
    display: "flex",
    flexDirection: "column",

    flex: 1,
    minHeight: 0,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  } as React.CSSProperties,
  sectionTitle: {
    ...textStyles.h3,
    color: Colors.grey800,
    marginBottom: "18px",
  } as React.CSSProperties,
  sectionSubtitle: {
    ...textStyles.body2,
    color: Colors.grey600,
    marginTop: "-8px",
    marginBottom: "18px",
  } as React.CSSProperties,
  inputGrid: {
    width: "100%",
    display: "flex",
    gap: "18px",
  } as React.CSSProperties,
  formItem: {
    marginBottom: 0,
    width: "100%",
    minHeight: "84px",
  } as React.CSSProperties,
  inputWrap: {
    position: "relative",
    width: "100%",
  } as React.CSSProperties,
  floatingLabel: {
    position: "absolute",
    top: "-7px",
    left: "10px",
    zIndex: 1,
    padding: "0 4px",
    background: "linear-gradient(to bottom, transparent 40%, white 40%)",
    transition: "0.2s ease all",
    ...textStyles.h6,
    color: Colors.grey400,
  } as React.CSSProperties,
  customPlaceholder: {
    position: "absolute",
    top: "50%",
    left: "44px",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    transition: "0.2s ease all",
    ...textStyles.body2,
    color: Colors.grey400,
    zIndex: 1,
  } as React.CSSProperties,
  input: {
    width: "100%",
    height: "44px",
    borderRadius: "8px",
    borderColor: Colors.grey100,
    boxShadow: "none",
    ...textStyles.body2,
    color: Colors.grey800,
  } as React.CSSProperties,
  inputError: {
    border: `1px solid ${Colors.red600}`,
    borderColor: Colors.red600,
    boxShadow: "none",
  } as React.CSSProperties,
  inputPrefix: {
    color: Colors.grey400,
    fontSize: "20px",
    marginRight: "10px",
  } as React.CSSProperties,
  inputRule: {
    ...textStyles.body3,
    color: Colors.red600,
  } as React.CSSProperties,
  timeGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "18px",
  } as React.CSSProperties,
  radioCard: {
    display: "flex",
    alignItems: "center",
    minHeight: "44px",
    borderRadius: "8px",
    border: `1px solid ${Colors.grey100}`,
    padding: "0 18px",
    backgroundColor: Colors.white,
    cursor: "pointer",
    transition: "all 0.2s ease",
  } as React.CSSProperties,
  radioCardActive: {
    border: `1px solid ${Colors.violet600}`,
  } as React.CSSProperties,
  radio: {
    width: "100%",
    marginRight: 0,
    display: "flex",
    alignItems: "center",
    ...textStyles.subtitle1,
    color: Colors.font.primary.fakeBlack,
  } as React.CSSProperties,
  buttonWrap: {
    marginTop: "auto",
    paddingTop: "8px",
  } as React.CSSProperties,
  submitButton: {
    marginTop: "20px",
    width: "100%",
    height: "56px",
    borderRadius: "999px",
    border: "none",
    ...textStyles.subtitle1,
    color: Colors.white,
    background: Colors.violet,
    boxShadow: "0 18px 30px rgba(122, 53, 240, 0.22)",
  } as React.CSSProperties,
  submitButtonDisabled: {
    boxShadow: "none",
  } as React.CSSProperties,
  exclamationIcon: {
    color: Colors.red600,
    marginRight: "6px",
  } as React.CSSProperties,
};
